/** Ancho del sidebar expandido/colapsado — compartido reclutador/candidato. */
export const SIDEBAR_WIDTH_EXPANDED = 280
export const SIDEBAR_WIDTH_COLLAPSED = 56

export const SIDEBAR_COLLAPSE_EASING = 'cubic-bezier(0.16, 1, 0.3, 1)'
export const SIDEBAR_COLLAPSE_DURATION = '0.35s'
